function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { notifyManager } from './notifyManager.esm.js';
import { Mutation } from './mutation.esm.js';
import { matchMutation, noop } from './utils.esm.js';
import { Subscribable } from './subscribable.esm.js';

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  function MutationCache(config) {
    var _this;
    _classCallCheck(this, MutationCache);
    _this = _callSuper(this, MutationCache);
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }
  _inherits(MutationCache, _Subscribable);
  return _createClass(MutationCache, [{
    key: "build",
    value: function build(client, options, state) {
      var mutation = new Mutation({
        mutationCache: this,
        logger: client.getLogger(),
        mutationId: ++this.mutationId,
        options: client.defaultMutationOptions(options),
        state: state,
        defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
      });
      this.add(mutation);
      return mutation;
    }
  }, {
    key: "add",
    value: function add(mutation) {
      this.mutations.push(mutation);
      this.notify({
        type: 'added',
        mutation: mutation
      });
    }
  }, {
    key: "remove",
    value: function remove(mutation) {
      this.mutations = this.mutations.filter(function (x) {
        return x !== mutation;
      });
      this.notify({
        type: 'removed',
        mutation: mutation
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;
      notifyManager.batch(function () {
        _this2.mutations.forEach(function (mutation) {
          _this2.remove(mutation);
        });
      });
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.mutations;
    }
  }, {
    key: "find",
    value: function find(filters) {
      if (typeof filters.exact === 'undefined') {
        filters.exact = true;
      }
      return this.mutations.find(function (mutation) {
        return matchMutation(filters, mutation);
      });
    }
  }, {
    key: "findAll",
    value: function findAll(filters) {
      return this.mutations.filter(function (mutation) {
        return matchMutation(filters, mutation);
      });
    }
  }, {
    key: "notify",
    value: function notify(event) {
      var _this3 = this;
      notifyManager.batch(function () {
        _this3.listeners.forEach(function (_ref) {
          var listener = _ref.listener;
          listener(event);
        });
      });
    }
  }, {
    key: "resumePausedMutations",
    value: function resumePausedMutations() {
      var _this4 = this;
      var _this$resuming;
      this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(function () {
        var pausedMutations = _this4.mutations.filter(function (x) {
          return x.state.isPaused;
        });
        return notifyManager.batch(function () {
          return pausedMutations.reduce(function (promise, mutation) {
            return promise.then(function () {
              return mutation.continue().catch(noop);
            });
          }, Promise.resolve());
        });
      }).then(function () {
        _this4.resuming = undefined;
      });
      return this.resuming;
    }
  }]);
}(Subscribable);
export { MutationCache };